module.exports = __webpack_public_path__ + "img/example2.0056a3ed.png";